if (!customElements.get("video-controls")) {
	customElements.define(
		"video-controls",
		class VideoControls extends HTMLElement {
			constructor() {
				super();

				if (this.dataset && this.dataset.target)
					this.target = document.getElementById(this.dataset.target);
				this.buttons = this.querySelectorAll(".video-controls__button");
				this.buttons?.forEach((btn) =>
					btn.addEventListener("click", () => this.handleAction(btn)),
				);
			}

			handleAction(btn) {
				if (!this.target) return;

				if (btn.classList.contains("playing")) {
					this.target.pause();
					btn.classList.remove("playing");
					btn.classList.add("paused");
					btn.setAttribute("aria-pressed", "false");
					if (btn.dataset.playLabel)
						btn.setAttribute("aria-label", btn.dataset.playLabel);
				} else if (btn.classList.contains("paused")) {
					this.target.play();
					btn.classList.remove("paused");
					btn.classList.add("playing");
					btn.setAttribute("aria-pressed", "true");
					if (btn.dataset.pauseLabel)
						btn.setAttribute("aria-label", btn.dataset.pauseLabel);
				}
			}
		},
	);
}
